import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import TransitionRouter from "../common/transitionRouter";
import { actions as bookmakersInfoActions } from "../common/bookmakersInfo";
import { actions as bookmakerListActions } from "../common/bookmakersList";
import bookmakersSorting from "../common/utils/bookmakersSorting";
import { getCurrentTime } from "../common/utils/currentDate";
import { getCookie, setCookie } from "../common/utils/cookie";
import "./styles.scss";
import LoginPage from "./loginPage";
import ForgottenPasswordPage from "./forgottenPasswordPage";
import AccountPage from "./accountPage";

export class BookmakersSwitcher extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentWillMount() {
		if (!this.props.bookmakersOrder || this.props.orderExpiration < getCurrentTime()) {
			this.props.setBookmakersOrder(bookmakersSorting, this.props.bookmakersList);
		}

		this.handleJustLoggedInBookmaker(this.props);
	}

	componentDidMount() {
		const { selectedBookmaker } = this.props;

		if (getCookie("chooseBookie") !== selectedBookmaker && selectedBookmaker !== null) {
			const date = new Date();

			date.setFullYear(date.getFullYear() + 1);
			setCookie(
				`chooseBookie=${selectedBookmaker}; ` +
					`domain=.${location.host.split(".").slice(1).join(".")}; ` +
					"path=/; " +
					`expires=${date.toUTCString()}`
			);
		}
	}

	componentWillReceiveProps(nextProps) {
		this.handleJustLoggedInBookmaker(nextProps);
	}

	handleJustLoggedInBookmaker = ({
		selectedBookmaker,
		bookmakersList,
		clearJustLoggedInBookmaker,
	}) => {
		const justLoggedInBookmaker = bookmakersList.find(({ justLoggedIn }) => justLoggedIn);
		if (justLoggedInBookmaker) {
			clearJustLoggedInBookmaker();
			if (justLoggedInBookmaker.feed !== selectedBookmaker) {
				this.setState({ justLoggedInBookmaker });
			}
		}
	};

	selectLoggedInBookmaker = () => {
		const { bookmakersList } = this.props;
		const {
			justLoggedInBookmaker: { feed },
		} = this.state;
		this.closeSelectLoggedInModal();
		this.props.selectBookmaker(feed, bookmakersSorting, bookmakersList);
	};

	closeSelectLoggedInModal = () => {
		this.setState({
			justLoggedInBookmaker: null,
		});
	};

	render() {
		const { bookmakersList, onHistoryChanged, selectedBookmakerFeed, children } = this.props;
		const trackedHistoryParams = "/:feed";
		const selectedBookmakerInfo = bookmakersList.find(
			({ feed }) => feed === selectedBookmakerFeed
		);

		return (
			<TransitionRouter
				onHistoryChanged={onHistoryChanged}
				trackedParams={trackedHistoryParams}
				selectedBookmakerFeed={selectedBookmakerFeed}
				bookmakerName={selectedBookmakerInfo.name}
			>
				<Route path='/:feed/login' component={LoginPage} />
				<Route path='/:feed/forgotten-password' component={ForgottenPasswordPage} />
				<Route path='/:feed/account' component={AccountPage} />

				{children}
			</TransitionRouter>
		);
	}
}

const mapStateToProps = (state) => {
	const { bookmakersList, bookmakersInfo, modals } = state;
	const { bookmakersOrder, orderExpiration, selectedBookmaker } = bookmakersInfo;
	return {
		bookmakersOrder,
		orderExpiration,
		bookmakersList,
		selectedBookmaker,
		isSelectionInfoModalVisible: modals.isSelectionInfoModalVisible,
		selectedBookmakerFeed: bookmakersInfo.selectedBookmaker,
	};
};

export default connect(mapStateToProps, {
	selectBookmaker: bookmakersInfoActions.selectBookmaker,
	setBookmakersOrder: bookmakersInfoActions.setBookmakersOrder,
	clearJustLoggedInBookmaker: bookmakerListActions.clearJustLoggedInBookmaker,
})(BookmakersSwitcher);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/BookmakersSwitcher.jsx